import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { appInfo } from './app-info';
import { PublicCompetitionPage, PublicHomePage } from './public';
import { PublicHeader } from './layouts';
import AppSettings from './pages/settings/app-settings';
import appUpdateService from './services/AppUpdateService';

export const UnauthenticatedContent = () => {
  useEffect(() => {
    // Initialize app update service auch für nicht authentifizierte Benutzer
    appUpdateService.initialize().catch(error => {
      console.error('Failed to initialize app update service:', error);
    });
  }, []);

  return (
    <PublicHeader title={appInfo.title}>
      <Routes>
        <Route
          path='/home'
          element={
            <PublicHomePage />
          }
        />
        {/* Neue flexible Wettkampf-Routen */}
        <Route
          path='/competition/:competitionName/:section?/:setting1?/:setting2?/:setting3?/:setting4?'
          element={
            <PublicCompetitionPage />
          }
        />
        <Route
          path='/settings/app'
          element={
            <AppSettings />
          }
        />
        <Route path='*' element={<Navigate to='/home' />} />
      </Routes>
    </PublicHeader>
  );
};
